module.exports = __webpack_public_path__ + "static/media/BP.70db51bf.webp";